import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="back-button"
export default class extends Controller {
  connect() {
    window.setTimeout(() => {
        window.scrollTo(0, 0)
    }, 1)

    this.defineBackButtonLink()
  }

  defineBackButtonLink() {
  }
}
